import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    events: [],
  },
  mutations: {
    startFetch(state) {
      state.fetchInProgress = true
    },
    setData(state, events) {
      state.events = events
    },
    stopFetch(state) {
      state.fetchInProgress = false
    },
  },
  actions: {
    async fetch({ commit, state }, params) {
      params = params || {}
      commit('startFetch')
      const response = await http.getAuthed(`/events`, params)
      commit('setData', response.data.results)
      commit('stopFetch')
    },
    async create({ commit, state }, { name, organizationId }) {
      const response = await http.postAuthed(`/events/create`, {
        name,
        organization_id: organizationId,
      })
      return response
    },
  },
}
